"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../../ApiManagerAdmin");
var ApiConfig_1 = require("../../config/ApiConfig");
var ApiComic = /** @class */ (function (_super) {
    __extends(ApiComic, _super);
    function ApiComic() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_COMIC_DATE = "/api/statistics/statisticsComicsViewByDate";
        _this.GET_EPISODE_DATE = "/api/statistics/statisticsEpisodeViewByDate";
        /**
         * 만화별 통계 api
         * request property
         * @accessToken : 인증키
         * @request
         * - start : 조회 시작 날짜
         * - end : 조회 끝 날짜
         * - language : 만화 언어 (en...)
         * - timezone : 지역정보 (KST:한국 / EST:동부시)
         */
        _this.getComicDate = function (accesstoken, request) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_COMIC_DATE,
                data: request,
            });
        };
        /**
         * 회차리스트 통계 api
         * request property
         * @accessToken : 인증키
         * @request
         * - start : 조회 시작 날짜
         * - end : 조회 끝 날짜
         * - language : 만화 언어 (en...)
         * - timezone : 지역정보 (KST:한국 / EST:동부시)
         * - page: 현재 페이지
         * - limit: row 제한
         * - comicId: 만화 id (전체는 null)
         */
        _this.getEpisodeDate = function (accesstoken, request) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_EPISODE_DATE,
                data: request,
            });
        };
        return _this;
    }
    ApiComic.getInstance = function (initValue) {
        if (!ApiComic.classInstance) {
            this.classInstance = new ApiComic(initValue);
        }
        return this.classInstance;
    };
    return ApiComic;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiComic;
